import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { BulkCloseRequest, BulkCloseResponse } from '@produzionejb/types';
import { api } from './api-client';

/**
 * Chiude N documenti PSC o LNP dentro una singola transaction atomica server-side.
 * Replica `chiudiDocumentiSelezionati` Drive CDC.
 *
 * Invalidation: lista DRAFT + lista CLOSED del tipo + stock-movements + lots
 * (i lotti aggiornano residualQty al close).
 */
export function useBulkClose() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: BulkCloseRequest) =>
      api<BulkCloseResponse>('/api/documents/bulk-close', {
        method: 'POST',
        body: req,
      }),
    onSuccess: (_data, variables) => {
      const queryKey = variables.type === 'PSC' ? 'psc-documents' : 'lnp-documents';
      void qc.invalidateQueries({ queryKey: [queryKey, 'list'] });
      void qc.invalidateQueries({ queryKey: ['lots', 'list'] });
      void qc.invalidateQueries({ queryKey: ['stock-movements', 'list'] });
    },
  });
}
